import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { sync } from "vuex-router-sync";
import store from './store'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'

Vue.config.productionTip = false

sync(store, router);
if (window.localStorage) {
    var localUserString = window.localStorage.getItem("userInfo") || "null";
    var localUser = JSON.parse(localUserString);

    if (localUser && store.state.userInfo !== localUser) {
        store.commit("SET_USERINFO", localUser);
    }
}

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
